import { Link } from 'react-router-dom';
import { movieCategories } from '@/mocks/movies';

export default function CategoryNav() {
  return (
    <section className="w-full px-4 md:px-6">
      <div className="max-w-[1200px] mx-auto">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-100">
            <a href="#categories">电影分类</a>
          </h2>
          <Link
            to="/category/dongzuo"
            className="text-sm text-foreground-500 hover:text-primary-400 transition-colors flex items-center gap-1 cursor-pointer whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 lg:grid-cols-10 gap-3">
          {movieCategories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-2 p-4 rounded-xl bg-background-700/40 border border-background-700/40 hover:border-primary-500/30 hover:bg-background-700/60 transition-all duration-300 cursor-pointer"
              title={`${cat.name}在线观看`}
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-background-600/50 group-hover:bg-primary-500/20 transition-colors duration-300">
                <i className={`${cat.icon} text-lg text-foreground-400 group-hover:text-primary-400 transition-colors duration-300`}></i>
              </div>
              <span className="text-xs font-medium text-foreground-400 group-hover:text-foreground-200 transition-colors duration-300 whitespace-nowrap">
                {cat.name}
              </span>
              <span className="text-[10px] text-foreground-600">{cat.count}部</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}